import { jsonMember, jsonObject } from 'typedjson';
import { Guid } from '@web/utils';

@jsonObject
export class AdminOrderMarkAsCompleteResponse {
  @jsonMember(String)
  public readonly id!: Guid;
}
